"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reducers = require("../../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../../redux/sagas"));
var _constants = require("../../../utils/constants");
var _ErrorBoundary = require("../../../components/ErrorBoundary");
var _ThreeDStructureConnect = require("./ThreeDStructureConnect");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ThreeDStructureInject = props => {
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      viewer: _reducers.viewer,
      components: _reducers.components
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(_ThreeDStructureConnect.ThreeDStructureConnect, props);
};

// eslint-disable-next-line import/no-default-export
var _default = exports.default = (0, _ErrorBoundary.ErrorBoundary)(ThreeDStructureInject);